import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Star, Gift, Percent, Calendar, ChevronRight, CreditCard, ShoppingCart, Store, Wallet, Package, Tag, Award, Zap, Clock, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import "./BenefitExplained.css";

export default function BenefitExplained() {
    const { t, i18n } = useTranslation();
    const clubId = useParams();
    const navigate = useNavigate();
    const isRTL = i18n.language === 'he';

    const benefits = [
        {
            id: 1,
            name: t('prepaidCardAll'),
            icon: <Star className="benefit-explained-icon" />,
            description: t('prepaidCardDescription'),
            buttonText: t('createPrepaidCard'),
            type: "prepaid",
            prepaidSubtype: "all",
            isPremium: true,
            advantages: [
                { icon: <CreditCard className="advantage-icon" />, text: t('advantage1') },
                { icon: <ShoppingCart className="advantage-icon" />, text: t('advantage2') },
                { icon: <Store className="advantage-icon" />, text: t('advantage3') }
            ]
        },
        {
            id: 4,
            name: t('prepaidCardItems'),
            icon: <Star className="benefit-explained-icon" />,
            description: t('prepaidCardDescription'),
            buttonText: t('createPrepaidCard'),
            type: "prepaid",
            prepaidSubtype: "items",
            isPremium: true,
            advantages: [
                { icon: <Package className="advantage-icon" />, text: t('advantage1') },
                { icon: <Tag className="advantage-icon" />, text: t('advantage2') },
                { icon: <Award className="advantage-icon" />, text: t('advantage3') }
            ]
        },
        {
            id: 2,
            name: t('oneTimeBenefit'),
            icon: <Gift className="benefit-explained-icon" />,
            description: t('oneTimeBenefitDescription'),
            buttonText: t('createOneTimeBenefit'),
            type: "free",
            advantages: [
                { icon: <Zap className="advantage-icon" />, text: t('advantage1') },
                { icon: <Clock className="advantage-icon" />, text: t('advantage2') },
                { icon: <Users className="advantage-icon" />, text: t('advantage3') }
            ]
        },
        {
            id: 3,
            name: t('punchCard'),
            icon: <Percent className="benefit-explained-icon" />,
            description: t('punchCardDescription'),
            buttonText: t('createPunchCardBenefit'),
            type: "punch",
            advantages: [
                { icon: <Wallet className="advantage-icon" />, text: t('advantage1') },
                { icon: <Calendar className="advantage-icon" />, text: t('advantage2') },
                { icon: <Award className="advantage-icon" />, text: t('advantage3') }
            ]
        }
    ];

    const handleBenefitClick = (benefitType, prepaidSubtype) => {
        const clubBusinessMember = JSON.parse(localStorage.getItem("clubBusinessMember"));
        navigate(`/home/ManageClubs/${clubBusinessMember.id}/addFinal?type=${benefitType}&prepaidSubtype=${prepaidSubtype}`);
    };

    return (
        <div className={`benefits-explained-container ${isRTL ? 'rtl' : ''}`}>
            <div className="benefits-explained-content">
                <div className="benefits-explained-header">
                    <h1>{t('benefitSelection')}</h1>
                    <p>{t('selectBenefitTypeDescription')}</p>
                </div>

                <div className="benefits-explained-grid">
                    <div className="premium-indicator">
                        <span className="premium-badge">{t('premiumBenefits')}</span>
                    </div>
                    {benefits.map((benefit) => (
                        <div
                            key={benefit.id}
                            className={`benefit-explained-card ${benefit.isPremium ? 'premium-benefit' : ''}`}
                        >
                            <div className="benefit-explained-card-content">
                                <div className="benefit-explained-title-container">
                                    <h3>{benefit.name}</h3>
                                    <div className={`benefit-explained-icon-container ${benefit.isPremium ? 'premium' : ''}`}>
                                        {benefit.icon}
                                    </div>
                                </div>
                                <div className="benefit-explained-divider"></div>
                                <div className="benefit-advantages-container">
                                    {benefit.advantages.map((advantage, index) => (
                                        <div key={index} className={`advantage-row ${benefit.isPremium ? 'premium' : ''}`}>
                                            <div className="advantage-icon-wrapper">
                                                {advantage.icon}
                                            </div>
                                            <span className="advantage-text">{advantage.text}</span>
                                        </div>
                                    ))}
                                </div>
                                <button
                                    onClick={() => handleBenefitClick(benefit.type, benefit.prepaidSubtype)}
                                    className={`benefit-explained-button ${benefit.isPremium ? 'premium' : ''}`}
                                    type="button"
                                >
                                    {benefit.buttonText}
                                    <ChevronRight className="button-explained-icon" />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
